<div class="flex gap-[4px]">
  <div class="common-date__input-time-container"
    [ngClass]="{'common-date__input-time-container--sequential': field?.sequentialView && isLanding}">
    <input class="common-date__input-time"
      [ngClass]="{'common-date__input-time--sequential': field?.sequentialView && isLanding}"
      [id]="'input-date-day-' + inputDate.inputId"
      [(ngModel)]="inputDate.day"
      [disabled]="disabled"
      [pKeyFilter]="'int'"
      [placeholder]="'input-date.day' | afTranslate"
      maxlength="2"
      autocomplete="off"
      (keyup)="validateInputDate('day', $event)"/>
    <span>/</span>
    <input class="common-date__input-time"
      [ngClass]="{'common-date__input-time--sequential': field?.sequentialView && isLanding,
        'common-date__input-time--empty-month': !inputDate.month}"
      [id]="'input-date-month-' + inputDate.inputId"
      [(ngModel)]="inputDate.month"
      [disabled]="disabled"
      [pKeyFilter]="'int'"
      [placeholder]="'input-date.month' | afTranslate"
      maxlength="2"
      autocomplete="off"
      (keyup)="validateInputDate('month', $event)"/>
      <span>/</span>
    <input class="common-date__input-time-year"
      [ngClass]="{'common-date__input-time-year--sequential': field?.sequentialView && isLanding}"
      [id]="'input-date-year-' + inputDate.inputId"
      [(ngModel)]="inputDate.year"
      [disabled]="disabled"
      [pKeyFilter]="'int'"
      [placeholder]="'input-date.years' | afTranslate"
      maxlength="4"
      autocomplete="off"
      (keyup)="validateInputDate('year', $event)"/>
  </div>
  @if (field?.showTime) {
    <div class="common-date__input-time-container">
      <input class="common-date__input-hour"
        [ngClass]="{'common-date__input-hour--sequential': field?.sequentialView && isLanding}"
        [id]="'input-date-hour-' + inputDate.inputId"
        [(ngModel)]="inputDate.hours"
        [disabled]="disabled"
        [pKeyFilter]="'int'"
        placeholder="00"
        maxlength="2"
        autocomplete="off"
        (keyup)="validateInputDate('hours', $event)"
        (blur)="blurInputTime('hours')"/>
      <span>:</span>
      <input class="common-date__input-hour"
        [ngClass]="{'common-date__input-hour--sequential': field?.sequentialView && isLanding}"
        [id]="'input-date-minute-' + inputDate.inputId"
        [(ngModel)]="inputDate.minutes"
        [disabled]="disabled"
        [pKeyFilter]="'int'"
        placeholder="00"
        maxlength="2"
        autocomplete="off"
        (keyup)="validateInputDate('minutes', $event)"
        (blur)="blurInputTime('minutes')"/>
    </div>
  }
</div>
